import React from 'react';


 

import { Button } from 'element-react';
 

 

import KeeVue from '../base/KeeVue.js'
import FsRemovals from '../element/FsRemovals'

import FsButton from '../element/FsButton.js'
import FsRow from '../element/FsRow.js'
import FsCol from '../element/FsCol.js'
import FsSelect from '../element/FsSelect.js'
import FsTable from '../element/FsTable.js'
import FsForm from '../element/FsForm.js'
import FsInput from '../element/FsInput.js'
import FsIcon from '../element/FsIcon.js'
import FsPicSelect from '../element/FsPicSelect.js'

import FsText from '../element/FsText.js'
import FsLayout from '../element/FsLayout.js'

import FsTabs from '../element/FsTabs.js'
import FsTimeline from '../element/FsTimeline.js'
import FsUpload from '../element/FsUpload.js'
import FsUpload1 from '../element/FsUpload1.js'
import FsTreeMenu from '../element/FsTreeMenu.js'

import FsPic from '../element/layout/FsPic.js'

import FsResizeBtn from './FsResizeBtn.js'
import FsView from './FsView.js'

import FsCssManager from './FsCssManager.js'
import FsCard from '../element/FsCard.js'

import FsDropdown from '../element/FsDropdown.js'
import FsDivider from '../element/FsDivider.js'
import FsTag from '../element/FsTag.js'

import FsColor from '../element/FsColor.js'
import FsBox from '../element/FsBox.js'

import FsBreadcrumb from '../element/FsBreadcrumb.js'
import FsPdf from '../element/FsPdf'
import $ from 'jquery';



//props: ['components','cpstyle', 'parentLayout', 'po', 'name', 'query', 'debug', 'thisForm', 'parentForm', 'editable'],

export default class FeasComponent extends KeeVue {
	constructor(props) {
		super(props);

		this.state = {
			randId: this.getRandString(),
		};

	}
	

	componentWillMount() { }
	
	componentDidMount(){
		let c = this.props.component;
		
		if(this.props.debug)
		{ 
			window.domTargets[c.alias] = this.domTarget;
		}
		else
		{
			if(c&&c.viewName&&window.CReactMap[c.viewName])
			{
				if(!window.CReactMap[c.viewName].domTargets)
				{
					window.CReactMap[c.viewName].domTargets={};
				}
				
				window.CReactMap[c.viewName].domTargets[c.alias] = this.domTarget;
			}
		}
		
		 
		
	}

	// attrs: {
	// 				"tag": "fscomponents"
	// 			},
	// 			'style':this.cpstyle,
	// 			'class': {
	// 				'kee-full-div': (this.parentLayout != null ? true : false)
	// 			}
	// attrs: {
	// 						component: item,
	// 						components: components,
	// 						'po': this.po,
	// 						'this-form': this.thisForm,
	// 						'alias': item.alias,
	// 						'parent-form': this.parentForm,
	// 						'name': this.name,
	// 						'query': this.query,
	// 						'editable': this.editable,
	// 						'debug': this.props.debug,
	// 					},
	renderComponentItem = (item, index) => {

		// 看看有没有权限				
		if (this.isNotBlank(item.permission)) {
			if(!window.hasPermission(item.permission)&&this.props.debug != true)
			{
				return <div></div>;
			}
		}

		// 先创建一个 div 节点；
		let cls = "";
		if (this.props.debug === true) {
			cls += " kee-relative-div-m2px ";
			cls += " kee-comonent-div ";
		}
		else
		{
			cls += " kee-relative-div-m0 ";
		}
		if (item.name === 'el-col') {
			cls += " el-col el-col-" + item.cp.span;
		}
		// if(item.isKeeShowBorder == true && item.name != 'fs-box')
		// {
		// 	cls+=" kee-relative-margin"
		// }
		if (this.parentLayout && item.name == 'fs-layout') {
			cls += " kee-full-div ";
		}




		let CompItem = null;

		if (!item.name) {
			return '';
		}
		if(item.name === 'el-sremovals'){
			CompItem = FsRemovals;
		}
		if (item.name === 'el-button') {
			CompItem = FsButton;
		}

		if (item.name == "el-row") {

			CompItem = FsRow;
		}
		if (item.name == "el-col") {

			CompItem = FsCol;
		}
		if (item.name == "fs-form") {
			CompItem = FsForm;
		}
		if (item.name == "fs-table") {
			CompItem = FsTable;
		}
		
		if (item.name == "fs-text") {
			CompItem = FsText;
		}
		if(item.name=="fs-layout")
		{
			CompItem = FsLayout;
		}
		
		if(item.name=="fs-tabs")
		{
			CompItem = FsTabs;
		}
		
		if(item.name=="fs-tree-menu")
		{
			CompItem = FsTreeMenu;
		}
		if(item.name=="fs-icon")
		{
			CompItem = FsIcon;
		}
		if(item.name=="fs-pic-select")
		{
			CompItem = FsPicSelect;
		}
		
		
		if(item.name=='fs-timeline')
		{
			CompItem = FsTimeline;
		}
		
		
		
		if(item.name=='fs-upload')
		{
			CompItem = FsUpload;
		}
        if(item.name=='fs-upload1')
		{
			CompItem = FsInput;
		}

		if(item.name=='fs-view')
		{
			CompItem = FsView;
		}
		if(item.name=='fs-css-manager')
		{
			CompItem = FsCssManager;
		}
		if(item.name=='fs-pic')
		{
			CompItem = FsPic;
		}
		
		if(item.name=='fs-card')
		{
			CompItem = FsCard;
		}
		if(item.name=='fs-dropdown')
		{
			CompItem = FsDropdown;
		}
		
		if(item.name=='fs-divider')
		{
			CompItem = FsDivider;
		}
    
    	if(item.name=='fs-tag')
		{
			CompItem = FsTag;
		}
    
    if(item.name=='fs-breadcrumb')
		{
			CompItem = FsBreadcrumb;
		}
		if(item.name === 'el-sremovals'){
			CompItem = FsRemovals;
		}
    
    if(item.name === 'fs-pdf'){
        CompItem = FsPdf;
    }
		
		if(item.name=='fs-color')
		{
			//alert("color");
			CompItem = FsColor;
		}
		
		if(item.name=='fs-box')
		{
			CompItem = FsBox;
		}
		
		
		
		
		



		if (item.type == 'form' && item.name != 'el-button' && item.name != 'fs-text' ) {
			//		console.log("ddasdfasdf",this.props.thisForm);
			
			//console.log(item.name+"   hhhhhhhh:"+this.props.editable);
			
			CompItem = FsInput;
		}


		if (!CompItem) {
			return <div>{item.name} 组件未找到!</div>;
		}

		if (!item.style) {
			item.style = {};
		}
		let style = JSON.parse(JSON.stringify(item.style));
		if ((item.visiable != false) || this.props.debug == true) {
			style.display = item.style.display;
		}
		else {
			style.display = "none";
		}


		let zheZhao = this.props.debug == true && (item.child == null || item.child.length == 0) && item.name != 'fs-text' && item.name != 'fs-video' && item.name != 'fs-pic' && item.name != 'fs-rect' && item.name != 'el-col' && item.name != 'el-row' && item.name != 'fs-form' && item.name != 'fs-card';

		


		let showFsActive = this.props.debug == true && item.isKeeShowBorder == true;
		// if (item.name == 'fs-layout') {
		// 	style.position = "static";
		// }
		let resizeBtn = style.position != 'absolute' && item.isSelected == true && this.props.debug == true   ? <FsResizeBtn component={item}></FsResizeBtn> : <div></div>;


		let boxid = (item.name == 'fs-box' || item.name == 'fs-form' || item.name == 'fs-index-config' || item.name == 'fs-form-config' || item.name == 'fs-cms-config' || item.name == 'fs-table' || item.name == 'el-col' || item.name == 'el-row' || item.name == 'fs-card' || (item.isContainer == true && (item.type != 'form' && item.type != 'layout')) ? item.id : '')
		let customeProps = item.cp;




		if (item.name == 'el-row' && style != null && style.display == 'inline-block') {
			// 强行设置display 属性
			//style.display = 'block';

		}

		if (item.name == 'el-col') {
			//console.log("style.minHeight:::"+style.minHeight);
			if (!style.minHeight) {
				// style.minHeight = '40px';
			}
		//	console.log("style.minHeight:::"+style.minHeight);
		}

		if (style.display == 'inline-block') {
			//style.verticalAlign = "top";
		}
		
		if(typeof item.cp.visiable !="undefined"&&item.cp.visiable===false)
		{
			style.display ="none";
		}
		

		if (item.isKeeShowBorder == true && item.isSelected != true && item.name != 'fs-box') {
			cls += " kee-component-border";
		}
		if (item.isSelected == true || item.isKeeShowBorder == false|| item.isSystem) {
			cls += " kee-component-border-hide"
		}
		
		if (item.isSelected == true  ) {
			cls += " is-selected "
		}
		
		if(window.isReport&&this.props.debug&&item.name=='fs-form')
		{
			style.minHeight="1200px";
		}
		
		// 计算这个组件是否可以展示？
		
		if(item.visiable==false)
		{
			style.display = "none";
		}
		 

		return <div ref={(input) => {this.domTarget = input}} cname={item.name+"-"+item.alias} key={item.id} id={item.id} tid={item.id} boxid={boxid}
			className={`${cls} ${item.isKeeShowBorder == true && item.isSelected != true && item.name != 'fs-box' ? 'kee-component-border' : ''} ${item.isSelected == true || item.isKeeShowBorder == false ? 'kee-component-border-hide' : ''} ${item.bindClassName?item.bindClassName:''}`}
			style={style}> 
			 
			<CompItem component={item} po={this.props.po} 
				keePage={this.props.keePage} 
				thisForm={this.props.thisForm}
				name={this.props.name}
				query={this.props.query}
				editable={this.props.editable}
				onChanged={this.onChanged}
				onCommand={this.onCommand}

				onChildRefresh={() => { this.refresh();  }}

				debug={this.props.debug}   ></CompItem>

			{
				zheZhao && <div className={`kee-zhezhao`}></div>
			}
			{
				this.props.debug===true&&(!(window.isReport&&item.isSystem==true)) &&item.isSelected&&(!(window.isReport&&item.name=='fs-form'))&&<div className={`componentToolBtn`}>
				 <div className={`kee-left`} style={{width:' 100%'}} >
					 <Button type="text" size="small" title="复制组件"  style={{padding:'3px'}}  onClick={(e)=>{ this.sendEvent("copyComponent");this.sendEvent("pasteComponent")}} ><i className={`iconfont icon-app_btn_copy`} style={{color: 'rgba(48,111,220,1)', fontSize: '14px'}}></i></Button>
				   <Button type="text"  size="small" title="删除组件" style={{padding:'3px'}}  onClick={(e)=>{this.sendEvent("key.d")}} ><i className={`iconfont icon-app_ic_delete1`}  style={{color: 'rgba(48,111,220,1)', fontSize: '14px'}}></i></Button>
					 
				 </div>
				 
				</div>
			}

			{
				resizeBtn
			}

		</div>
	}

	// 向上传递命令
	onCommand = (cmdName, item, po, thisForm, parentForm) => {
		//console.log(" 收到command事件：" + cmdName);
		if (cmdName == 'remove') { 
			this.props.components.remove(thisForm); 
		}

		if (cmdName == 'add') {
			//this.components.push(item);
		} else {
			//console.log("向上传递command")
			this.$emit("command", cmdName, item, po, thisForm, parentForm);
		}

	}
	onChanged = (ret) => {
		this.$emit("changed", ret);
	}

	componentWillReceiveProps(nextProps) {
		//this.setState(this.state);
	}

	render() {

		return this.renderComponentItem(this.props.component, 0)


	}
}
